var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-col',{attrs:{"cols":"12"}},[_c('DataTable',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"rows":_vm.rows,"clases":"table-bordered table-hover table-condensed nowrap"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }